export const ROOT = 'evolve-dialog';
export const OPEN = `${ROOT}--open`;
export const ANIMATING = `${ROOT}--animating`;
export const BACKDROP = `${ROOT}__backdrop`;
export const SURFACE = `${ROOT}__surface`;

// header
export const HEADER = `${ROOT}__header`;
export const HEADER_TITLE = `${HEADER}__title`;

// body
export const BODY = `${ROOT}__body`;
export const SCROLLABLE = `${BODY}--scrollable`;
export const SCROLL_LOCK = `${ROOT}-scroll-lock`;

// footer
export const FOOTER = `${ROOT}__footer`;
export const FOOTER_BUTTON = `${FOOTER}__button`;
export const FOOTER_BUTTON_CANCEL = `${FOOTER_BUTTON}__cancel`;
export const FOOTER_NO_ORDER = `${FOOTER_BUTTON}__no__order`;
export const FOOTER_BUTTON_ACCEPT = `${FOOTER_BUTTON}__accept`;
